module.exports = __webpack_public_path__ + "static/img/ysfx3.691a1ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xinqingBrand/assets/ysfx3.png
// module id = /4Od
// module chunks = 0